import React from 'react';
import plusIcon from '../../../../assets/add.svg';

import styles from './Popup.module.scss';

interface Props {
  onClose?(): void;
}

const CloseButton = ({ onClose }: Props) => (
  <button
    className={styles.popup__close_icon_container}
    onClick={onClose}
    type="button"
  >
    <img className={styles.popup__close_icon} src={plusIcon} alt="close" />
  </button>
);

CloseButton.defaultProps = {
  onClose: () => {},
};

export default CloseButton;
